module.exports = __webpack_public_path__ + "img/tommaso-urli-tY3jC9HiKzE-unsplash.e5af4cd4.jpg";